import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const HyperLinkIcon: React.ComponentType<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 214 102">
    <svg fill="none">
      <path fill="#F9FBFD" d="M0 0h214v102H0z" />
      <path
        d="M21.39 60v-9.184h1.163v8.19h4.018V60h-5.18zm9.33.168c-.42 0-.822-.08-1.205-.238a3.014 3.014 0 01-.994-.686 3.568 3.568 0 01-.7-1.12 4.281 4.281 0 01-.252-1.512c0-.57.084-1.073.252-1.512.178-.448.411-.826.7-1.134.29-.308.621-.541.994-.7a3.112 3.112 0 011.204-.238 3.01 3.01 0 012.198.938c.29.308.518.686.686 1.134.178.439.266.943.266 1.512a4.08 4.08 0 01-.266 1.512 3.378 3.378 0 01-.686 1.12 2.97 2.97 0 01-1.008.686 3.01 3.01 0 01-1.19.238zm0-.952c.289 0 .555-.06.797-.182a1.86 1.86 0 00.616-.532 2.53 2.53 0 00.406-.826c.094-.317.14-.672.14-1.064s-.046-.747-.14-1.064a2.514 2.514 0 00-.406-.84 1.678 1.678 0 00-.616-.532 1.656 1.656 0 00-.798-.196c-.289 0-.555.065-.798.196a1.797 1.797 0 00-.63.532 2.687 2.687 0 00-.392.84c-.093.317-.14.672-.14 1.064s.047.747.14 1.064c.094.317.224.593.392.826.178.224.388.401.63.532.243.121.51.182.798.182zm5.09.784v-6.804h.952l.098 1.232h.042c.234-.43.514-.77.84-1.022.336-.252.7-.378 1.092-.378.27 0 .514.047.728.14l-.224 1.008a1.825 1.825 0 00-.658-.112c-.29 0-.592.117-.91.35-.308.233-.578.64-.812 1.218V60H35.81zm7.625.168a3.47 3.47 0 01-1.288-.238 3.275 3.275 0 01-1.036-.7 3.377 3.377 0 01-.686-1.12 4.166 4.166 0 01-.252-1.498c0-.56.084-1.06.252-1.498.177-.448.406-.826.686-1.134.29-.308.616-.541.98-.7a2.677 2.677 0 011.134-.252 2.8 2.8 0 011.148.224c.345.15.63.364.854.644.233.28.41.616.532 1.008.121.392.182.83.182 1.316 0 .121-.005.243-.014.364 0 .112-.01.21-.028.294h-4.592c.047.728.27 1.307.672 1.736.41.42.943.63 1.596.63.327 0 .625-.047.896-.14a4.22 4.22 0 00.798-.392l.406.756c-.299.187-.63.35-.994.49s-.78.21-1.246.21zm-2.142-4.116h3.64c0-.69-.15-1.213-.448-1.568-.29-.364-.7-.546-1.232-.546-.243 0-.476.047-.7.14-.215.093-.41.233-.588.42a2.27 2.27 0 00-.448.658 3.15 3.15 0 00-.224.896zM47.774 60v-6.804h.951l.098.98h.042c.3-.327.621-.597.966-.812a2.11 2.11 0 011.148-.336c.523 0 .93.117 1.218.35.3.224.518.541.658.952.355-.392.71-.705 1.064-.938a2.08 2.08 0 011.176-.364c.7 0 1.218.224 1.554.672.346.448.518 1.11.518 1.988V60H56.02v-4.158c0-.644-.102-1.106-.308-1.386-.205-.29-.522-.434-.952-.434-.513 0-1.082.35-1.708 1.05V60h-1.148v-4.158c0-.644-.102-1.106-.308-1.386-.205-.29-.527-.434-.966-.434-.513 0-1.082.35-1.708 1.05V60h-1.148zm12.359-4.886a.846.846 0 01-.602-.238.882.882 0 01-.238-.63c0-.27.08-.485.238-.644a.822.822 0 01.602-.252c.224 0 .415.084.574.252.168.159.252.373.252.644a.855.855 0 01-.252.63.782.782 0 01-.574.238zm0 5.054a.846.846 0 01-.602-.238.882.882 0 01-.238-.63c0-.27.08-.485.238-.644a.822.822 0 01.602-.252c.224 0 .415.084.574.252.168.159.252.373.252.644a.855.855 0 01-.252.63.782.782 0 01-.574.238z"
        fill="#757575"
      />
      <g clipPath="url(#prefix__clip0)" opacity={0.4}>
        <path
          d="M85.25 61.192a5.968 5.968 0 01-2.015-.336 4.64 4.64 0 01-1.616-1.024 4.799 4.799 0 01-1.088-1.664c-.256-.672-.384-1.445-.384-2.32 0-.864.133-1.632.4-2.304a5.082 5.082 0 011.088-1.728 4.773 4.773 0 011.632-1.072 5.29 5.29 0 011.968-.368c.757 0 1.408.139 1.952.416.544.277.987.592 1.328.944l-1.232 1.504a4.492 4.492 0 00-.848-.592c-.299-.16-.672-.24-1.12-.24-.405 0-.779.08-1.12.24-.33.15-.619.368-.864.656a3.15 3.15 0 00-.576 1.056 4.782 4.782 0 00-.192 1.408c0 1.077.24 1.915.72 2.512.49.587 1.227.88 2.208.88.213 0 .421-.027.624-.08.203-.053.368-.133.496-.24v-1.792h-1.728v-1.92h3.808v4.8c-.363.352-.843.65-1.44.896-.597.245-1.264.368-2 .368zm8.962 0c-.501 0-.987-.09-1.456-.272a3.889 3.889 0 01-1.248-.816 3.961 3.961 0 01-.848-1.296c-.213-.523-.32-1.115-.32-1.776s.107-1.248.32-1.76c.213-.523.496-.96.848-1.312a3.676 3.676 0 011.248-.8 3.81 3.81 0 011.456-.288c.501 0 .981.096 1.44.288.47.181.88.448 1.232.8.363.352.65.79.864 1.312.213.512.32 1.099.32 1.76s-.107 1.253-.32 1.776a3.836 3.836 0 01-.864 1.296 3.71 3.71 0 01-1.232.816 3.882 3.882 0 01-1.44.272zm0-1.904c.48 0 .843-.203 1.088-.608.245-.405.368-.955.368-1.648s-.123-1.243-.368-1.648c-.245-.405-.608-.608-1.088-.608-.49 0-.859.203-1.104.608-.235.405-.352.955-.352 1.648s.117 1.243.352 1.648c.245.405.613.608 1.104.608zm12.026 1.904c-.49 0-.912-.075-1.264-.224a2.284 2.284 0 01-.848-.624 2.719 2.719 0 01-.48-.96 5.208 5.208 0 01-.144-1.264v-3.216h-1.088V53.16l1.216-.096.272-2.112h1.952v2.112h1.904v1.84h-1.904v3.184c0 .448.091.773.272.976.192.192.443.288.752.288.128 0 .256-.016.384-.048.139-.032.262-.07.368-.112l.368 1.712c-.213.064-.464.128-.752.192a4.687 4.687 0 01-1.008.096zm6.346 0c-.501 0-.987-.09-1.456-.272a3.898 3.898 0 01-1.248-.816 3.956 3.956 0 01-.848-1.296c-.213-.523-.32-1.115-.32-1.776s.107-1.248.32-1.76a3.92 3.92 0 01.848-1.312 3.684 3.684 0 011.248-.8 3.81 3.81 0 011.456-.288c.501 0 .981.096 1.44.288.469.181.88.448 1.232.8.363.352.651.79.864 1.312.213.512.32 1.099.32 1.76s-.107 1.253-.32 1.776a3.825 3.825 0 01-.864 1.296 3.713 3.713 0 01-1.232.816 3.885 3.885 0 01-1.44.272zm0-1.904c.48 0 .843-.203 1.088-.608.245-.405.368-.955.368-1.648s-.123-1.243-.368-1.648c-.245-.405-.608-.608-1.088-.608-.491 0-.859.203-1.104.608-.235.405-.352.955-.352 1.648s.117 1.243.352 1.648c.245.405.613.608 1.104.608zM121.746 61V50.568h2.352v8.448h4.128V61h-6.48zm8.239 0v-7.936h2.352V61h-2.352zm1.168-9.104c-.394 0-.72-.112-.976-.336a1.162 1.162 0 01-.384-.896c0-.363.128-.656.384-.88.256-.224.582-.336.976-.336.406 0 .731.112.976.336.256.224.384.517.384.88s-.128.661-.384.896c-.245.224-.57.336-.976.336zM134.557 61v-7.936h1.92l.16 1.008h.064c.342-.32.715-.597 1.12-.832.406-.245.88-.368 1.424-.368.864 0 1.488.283 1.872.848.395.565.592 1.35.592 2.352V61h-2.352v-4.624c0-.576-.08-.97-.24-1.184-.149-.213-.394-.32-.736-.32-.298 0-.554.07-.768.208a4.127 4.127 0 00-.704.56V61h-2.352zm9.306 0V49.784h2.288v6.432h.064l2.512-3.152h2.56l-2.784 3.264L151.495 61h-2.544l-1.792-3.088-1.008 1.136V61h-2.288z"
          fill="#2962FF"
        />
      </g>
      <rect
        opacity={0.4}
        x={79}
        y={25}
        width={114}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={79}
        y={75}
        width={89}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={20}
        y={25}
        width={36}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={20}
        y={75}
        width={29}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={174}
        y={75}
        width={8}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <g filter="url(#prefix__filter0_d)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M161.027 69.088l.004-.007.022.082-.026-.075zm1.495 5.472a.51.51 0 01.092-.29l.848-1.194a2.928 2.928 0 00.542-1.703v-4.876c0-2.075-.221-2.417-.976-2.481v1.481a.499.499 0 11-1 0v-1.925c-.058-.176-.288-.653-1.058-.643v2.568a.5.5 0 11-1 0v-2.903c-.094-.166-.371-.552-.885-.597v3.5a.5.5 0 11-1 0v-3.424c-.001-.012-.007-.022-.007-.034v-2.042c0-.558-.387-.986-.9-.997-.547.012-1.064.487-1.064.997v7.157a.5.5 0 01-.887.318L153.7 65.61a1.027 1.027 0 00-.712-.291h-.001c-.272 0-.536.115-.744.325-.328.333-.316.891.026 1.244l1.38 1.976c.619.889 1.117 1.86 1.479 2.884.329 1.004 1.099 2.473 1.718 2.473a.5.5 0 01.5.499l.001.777h5.175v-.937z"
          fill="#fff"
        />
        <mask id="prefix__a" maskUnits="userSpaceOnUse" x={164} y={65} width={2} height={2}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M165.085 65.882v1h-.102v-1h.102z"
            fill="#fff"
          />
        </mask>
        <mask id="prefix__b" maskUnits="userSpaceOnUse" x={155} y={77} width={2} height={2}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M156.341 78.498h-1v-.662h1v.662z"
            fill="#fff"
          />
        </mask>
        <mask id="prefix__c" maskUnits="userSpaceOnUse" x={164} y={75} width={2} height={2}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M165.085 75.615v1h-.916v-1h.916z"
            fill="#fff"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M156.001 75.615zm7.584.883h-7a.5.5 0 000 1h7a.5.5 0 000-1z"
          fill="#fff"
        />
        <mask id="prefix__d" maskUnits="userSpaceOnUse" x={164} y={78} width={2} height={1}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M165.085 78.058v.44h-.917v-.44h.917z"
            fill="#fff"
          />
        </mask>
        <mask id="prefix__e" maskUnits="userSpaceOnUse" x={151} y={57} width={15} height={22}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M158.042 78.498H151V57.999h14.085v20.498h-7.043z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#prefix__e)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M163.584 77.498h-7a.5.5 0 010-1h7a.5.5 0 010 1zm-6.237-2l-.002-.779a.5.5 0 00-.5-.498c-.618 0-1.389-1.47-1.718-2.472a12.043 12.043 0 00-1.479-2.884l-1.379-1.977c-.343-.353-.355-.912-.027-1.244a1.05 1.05 0 01.744-.326h.001c.272 0 .536.117.712.293l1.528 1.86a.5.5 0 00.886-.317v-7.156c0-.511.517-.986 1.064-.998.513.01.9.44.9.998v2.041c0 .012.006.023.007.033v3.425a.5.5 0 001 0v-3.5c.514.045.791.43.885.597v2.904a.5.5 0 101 0v-2.57c.77-.008 1 .469 1.058.644v1.925a.5.5 0 001 0v-1.48c.755.064.976.406.976 2.48v4.876c0 .615-.188 1.204-.542 1.703l-.848 1.195a.508.508 0 00-.091.288v.939h-5.175zm7.298.438a1.493 1.493 0 00-1.061-.439h-.062v-.778l.755-1.063c.475-.67.726-1.46.726-2.284v-4.874c0-.1-.007-.174-.009-.267a12.574 12.574 0 00-.011-.35c-.099-2.34-.774-2.804-2.109-2.873-.281-.553-.939-1.175-2.139-1.07a2.136 2.136 0 00-1.448-.907.49.49 0 00-.203-.045h-.007v-.988c0-1.1-.825-1.976-1.9-1.998-1.118.023-2.064.938-2.064 1.998v5.76l-.672-.816a2.031 2.031 0 00-1.454-.623h-.001c-.541 0-1.058.22-1.455.623-.708.717-.699 1.902-.032 2.58l1.329 1.912a11.084 11.084 0 011.352 2.636c.153.468.909 2.59 2.166 3.059l.001.392a1.48 1.48 0 00-.347.094 1.493 1.493 0 00-.916 1.382A1.493 1.493 0 00156 78.38c.18.076.377.118.584.118h7a1.493 1.493 0 001.061-.439 1.499 1.499 0 000-2.122z"
            fill="#212121"
          />
        </g>
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path
            d="M67 43a4 4 0 014-4h89a4 4 0 014 4v24a4 4 0 01-4 4H71a4 4 0 01-4-4V43z"
            fill="#fff"
          />
        </clipPath>
        <filter
          id="prefix__filter0_d"
          x={148}
          y={55.999}
          width={20.084}
          height={26.498}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1.5} />
          <feColorMatrix values="0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  </SvgIcon>
);

export default HyperLinkIcon;
